// export const baseUrl = "http://localhost:4000/api";
export const baseUrl = "https://api.hassala.app/api";
